module.exports = __webpack_public_path__ + "img/post_sample_instagram.6368fb96.png";